module.exports = __webpack_public_path__ + "static/media/more.52960d39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/more.svg
// module id = 521
// module chunks = 0